import { render, staticRenderFns } from "./new-search-num.vue?vue&type=template&id=593520b8&scoped=true&"
import script from "./new-search-num.vue?vue&type=script&lang=js&"
export * from "./new-search-num.vue?vue&type=script&lang=js&"
import style0 from "./new-search-num.vue?vue&type=style&index=0&id=593520b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593520b8",
  null
  
)

export default component.exports